import PropTypes from "prop-types"
import { useStageLeft } from "connected-components/agent-chat/chatbox/use-stage-left"
import GlobalNavRail from "."

/**
 * The rail + screen row shared by every layout that hosts the rail: `home-layout`,
 * `portfolio-root` and `watchlist-root`.
 *
 * Renders `.bottom > [rail, .content-column > [subnav, .content]]`. Each host's stylesheet
 * targets that chain with child combinators from its own root class (see the `nav-rail-shell`
 * mixin), so this must stay a direct child of `.modules_<shell>` and must not add wrappers.
 * `.content` is the containing block for side sheets rendered inside it — its box is
 * load-bearing, so hosts put their own `.main` / container markup in `children`.
 *
 * Also publishes where Kelly's full screen stops (ADR 0020 §3: "the publication moves with the
 * rail component"). One writer per mounted shell, covering all three, rather than each host
 * restating the condition.
 */
export default function NavRailShell({ children, subnav = null, searchModelId, showRail = true }) {
  useStageLeft(showRail)

  return <div className="bottom">
    {showRail && <GlobalNavRail searchModelId={searchModelId} />}
    <div className="content-column">
      {subnav}
      <div className="content">
        {children}
      </div>
    </div>
  </div>
}

NavRailShell.propTypes = {
  children: PropTypes.node,
  // Rendered above `.content`, unwrapped — hosts supply their own root element and class.
  subnav: PropTypes.node,
  searchModelId: PropTypes.string,
  showRail: PropTypes.bool,
}
